/*=========================================================================================
  File Name: moduleRequestTypeGetters.js
  Description: Request Type Module Getters
==========================================================================================*/

export default {};
